import { render, staticRenderFns } from "./university_userCenter.vue?vue&type=template&id=19d8f6f4&scoped=true&"
import script from "./university_userCenter.vue?vue&type=script&lang=js&"
export * from "./university_userCenter.vue?vue&type=script&lang=js&"
import style0 from "./university_userCenter.vue?vue&type=style&index=0&id=19d8f6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d8f6f4",
  null
  
)

export default component.exports